<p *ngIf="model.prefix" [innerHTML]="model.prefix" class="prefix-label-input"></p>
<mat-form-field
  [appearance]="model.getAdditional('appearance', 'outline')"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
  [mask]="{ mask: model.mask || false, showMask: model.mask && !model.placeholder }"
  [class]="model.id"
>
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label
      *ngIf="model.getAdditional('showLabelOnInit', true) ? true : isFocus"
      [innerHTML]="model.label"
    ></mat-label>
  </ng-container>

  <div *ngIf="checkPrefixId(model.id)" matPrefix class="prefix-contact-input">
    <span class="flag:{{ activeCountry$ | async }}"></span
    ><span class="flag-contact-number">{{ mobilePrefix$ | async }}</span>
  </div>

  <input
    matInput
    [attr.accept]="model.accept"
    [attr.max]="model.max"
    [attr.min]="model.min"
    [attr.multiple]="model.multiple"
    [attr.step]="model.step"
    [autocomplete]="model.autoComplete"
    [autofocus]="model.autoFocus"
    [errorStateMatcher]="model.getAdditional('errorStateMatcher', errorStateMatcher)"
    [formControlName]="model.id"
    [id]="id"
    [maxlength]="model.maxLength"
    [matAutocomplete]="matAutocomplete"
    [minlength]="model.minLength"
    [name]="model.name"
    [ngClass]="getClass('element', 'control')"
    [pattern]="model.pattern"
    [placeholder]="removeHTMLTags(model.placeholder)"
    [readonly]="model.readOnly"
    [required]="model.required"
    [spellcheck]="model.spellCheck"
    [tabindex]="model.tabIndex"
    [type]="model.inputType"
    (blur)="onBlur($event); checkInput(model.value)"
    (change)="onChange($event); checkInput(model.value)"
    (focus)="onFocus($event); ifFocus($event)"
  />

  <span *ngIf="model.suffix" matSuffix [innerHTML]="model.suffix"></span>

  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>

  <mat-hint *ngIf="showCharacterHint" align="end">{{ characterHint }}</mat-hint>

  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</mat-form-field>

<mat-autocomplete
  #matAutocomplete="matAutocomplete"
  [autoActiveFirstOption]="model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])"
  [disableRipple]="model.getAdditional('disableRipple', (RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled']) || false)"
  [displayWith]="model.getAdditional('displayWith', null)"
  (optionSelected)="onChange($event)"
>
  <ng-container *ngIf="model.getAdditional('matAutocomplete', null) === null; else displayWith">
    <mat-option *ngFor="let option of model.list$ | async" [value]="option">{{ option }}</mat-option>
  </ng-container>
  <ng-template #displayWith>
    <mat-option *ngFor="let option of model.list$ | async" [value]="option">
      {{ option[model.getAdditional('optionLabel', 'label')] }}
    </mat-option>
  </ng-template>
</mat-autocomplete>
